import { ILicenceProfile } from "../../api/ILicenceProfile";
import {
  GetLicenceVersionUrl,
  HasLicenceVersionPage,
} from "../../external-apps/Config";
import EpaCard from "../../leap-components/EpaCard";
import EpaField from "../../leap-components/EpaField";
import { EpaFieldHtml2 } from "../../leap-components/EpaFieldHtml2";

interface IActiveLicenceDetailsProps {
  licenceProfile: ILicenceProfile;
}

const ActiveLicenceDetails = ({
  licenceProfile,
}: IActiveLicenceDetailsProps) => {
  const hasLicenceVersionUrl = HasLicenceVersionPage(licenceProfile.type);
  const licenceLinkElement = (
    <EpaFieldHtml2
      label={"Reg No."}
      element={
        <a
          href={GetLicenceVersionUrl(
            licenceProfile.type,
            licenceProfile.profileNo,
            licenceProfile.activeLicenceVersion.licence_id,
            licenceProfile.activeLicenceVersion.reg_no
          )}
          target="_blank"
        >
          {licenceProfile.activeLicenceVersion.reg_no}
        </a>
      }
    />
  );
  const noLinkElement = (
    <EpaField
      label={"Reg No."}
      value={licenceProfile.activeLicenceVersion.reg_no}
    />
  );

  var bodyElements = (
    <div>
      {hasLicenceVersionUrl && licenceLinkElement}
      {!hasLicenceVersionUrl && noLinkElement}
      <EpaField label={"Issued"} value={licenceProfile.dateIssued} />
      <EpaField label={"Type"} value={licenceProfile.type} />
      <EpaField label={"Status"} value={licenceProfile.status} />
      <EpaField label={"Sub-status"} value={licenceProfile.subStatus} />
      <EpaField label={"Sector"} value={licenceProfile.sector} />
      <EpaField label={"Major Activity"} value={licenceProfile.majorActivity} />
      <EpaField label={"IED Activity"} value={licenceProfile.iedActivity} />
    </div>
  );

  return (
    <EpaCard title={"Active Authorisation Details"} content={bodyElements} />
  );
};

export default ActiveLicenceDetails;
